export default __webpack_public_path__ + "static/mid1-afba8cdcc34f4d6adb27a969b4b990cd.png";